import { render, staticRenderFns } from "./BaseAutocomplete.vue?vue&type=template&id=1bc36a88&"
import script from "./BaseAutocomplete.vue?vue&type=script&lang=ts&"
export * from "./BaseAutocomplete.vue?vue&type=script&lang=ts&"
import style0 from "./BaseAutocomplete.vue?vue&type=style&index=0&id=1bc36a88&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports